var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyProfileW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 19.1667C4.29917 19.1667 0 14.8675 0 9.58333C0 4.29917 4.29917 0 9.58333 0C14.8675 0 19.1667 4.29917 19.1667 9.58333C19.1667 14.8675 14.8675 19.1667 9.58333 19.1667ZM9.58333 0.833333C4.75833 0.833333 0.833333 4.75833 0.833333 9.58333C0.833333 14.4083 4.75833 18.3333 9.58333 18.3333C14.4083 18.3333 18.3333 14.4083 18.3333 9.58333C18.3333 4.75833 14.4083 0.833333 9.58333 0.833333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5832 15.0003C14.3532 15.0003 14.1665 14.8137 14.1665 14.5837C14.1665 12.0562 12.1107 10.0003 9.58317 10.0003C7.05567 10.0003 4.99984 12.0562 4.99984 14.5837C4.99984 14.8137 4.81317 15.0003 4.58317 15.0003C4.35317 15.0003 4.1665 14.8137 4.1665 14.5837C4.1665 11.597 6.5965 9.16699 9.58317 9.16699C12.5698 9.16699 14.9998 11.597 14.9998 14.5837C14.9998 14.8137 14.8132 15.0003 14.5832 15.0003Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58317 8.33333C7.97484 8.33333 6.6665 7.025 6.6665 5.41667C6.6665 3.80833 7.97484 2.5 9.58317 2.5C11.1915 2.5 12.4998 3.80833 12.4998 5.41667C12.4998 7.025 11.1915 8.33333 9.58317 8.33333ZM9.58317 3.33333C8.43484 3.33333 7.49984 4.26833 7.49984 5.41667C7.49984 6.565 8.43484 7.5 9.58317 7.5C10.7315 7.5 11.6665 6.565 11.6665 5.41667C11.6665 4.26833 10.7315 3.33333 9.58317 3.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyProfileW);
export default __webpack_public_path__ + "static/media/CompanyProfileW.e42dffe188d4a270aaf6b619d5c129a6.svg";
export { ForwardRef as ReactComponent };